import EmployeeTimeEntriesView from '@/views/Employee/EmployeeTimeEntriesView.vue';
import PostitView from '@/views/Employee/PostitView.vue';
import TimeClockView from '@/views/Employee/TimeClockView.vue';

const employeeRoutes = [
  {
    path: '/timeclock',
    name: 'timeclock',
    meta: {
      headerConfig: {
        headerLabel: 'timeclock',
        hide: false,
        showBack: true,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        requiredFeatures: [
          {
            feature: 'employees_included',
            minValue: 1,
          },
        ],
      },
      containerMargins: false,
    },
    component: TimeClockView,
  },
  {
    path: '/employee/postits/:id',
    meta: {
      headerConfig: {
        headerLabel: 'postit',
        hide: false,
        showBack: true,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        requiredFeatures: [
          {
            feature: 'employees_included',
            minValue: 1,
          },
        ],
      },
      containerMargins: true,
    },
    component: PostitView,
  },
  {
    path: '/employee/:restaurantUserId/time-entries',
    name: 'employee-time-entries',
    meta: {
      headerConfig: {
        headerLabel: 'timeEntries',
        hide: false,
        showBack: true,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        requiredFeatures: [
          {
            feature: 'employees_included',
            minValue: 1,
          },
        ],
      },
      containerMargins: true,
    },
    component: EmployeeTimeEntriesView,
  },
];

export default employeeRoutes;
